import type {ReactElement} from 'react';
import {BottomBarItem} from '@Components/contextual-menu/components/bottom-bar-item/bottom-bar-item';
import type {ControlTileProps} from './control-tile.types';
import styles from './control-tile.module.scss';

export function ControlTile({entry, onTileSelect}: ControlTileProps): ReactElement {
  const {meta, flatIndex} = entry;
  const label = window.i18next.t(meta.labelKey);

  function handleClick(): void {
    onTileSelect(flatIndex);
  }

  return <BottomBarItem id={`email-maker-control-tile-${String(flatIndex)}`} icon={meta.icon} text={label} textClasses={styles.label} onClick={handleClick} />;
}
